import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { getContentKeyAccToLang } from "../../utils/utils";
import { useLocation, useNavigate } from "react-router";
import { submitAccountClosureRequest } from "../../store/actions/settingAction";
import { useEffect } from "react";

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const pathname = useLocation()
  const { TextWeight, isArabic } = dynamicfunction();
  const { helpContent } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);
  const { settingLoading } = useSelector((state) => state.setting);

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      helpContent?.web_account_closure?.data?.attributes,
      key,
      isArabic
    );
  };

  useEffect(() => {
    if (process.env.REACT_APP_ENVIRONMENT === 'PRODUCTION') {
      navigate(-1)
    }
  }, [])

  const onSubmit = (values, resetForm) => {
    const api_data = {
      investorTypeId: user?.investorTypeId,
      closureReason: values?.reasonClosure,
    };

    dispatch(
      submitAccountClosureRequest(
        api_data,
        (res) => {
          resetForm();
        },
        (error) => {
          resetForm();
        }
      )
    );
  };

  return {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    onSubmit,
    settingLoading,
  };
};
